import { useEffect, useState } from "react";
import useFilteredHierarchies from "./hooks/useFilteredHierarchies";
import HierarchyTable from "./views/HierarchyTable";
import { useRecoilState } from "recoil";
import { hierarchyFilteredData } from "./atoms/atoms";

const Hierarchy = () => {
  const [filteredData, setFilteredData] = useState([]);
  const [filterInputData, setFilterInputData] = useRecoilState(
    hierarchyFilteredData
  );
  const [enableSearch] = useState(false);
  const [filterStatus, setFilterStatus] = useState(false);

  const {
    isSuccess: filterSuccess,
    data: filterResult,
    isLoading: filterLoading,
    refetch: filterRefetch,
  } = useFilteredHierarchies({
    filterInputData,
    enableSearch,
  });

  useEffect(() => {
    if (filterSuccess) {
      setFilterInputData((searchInputsData) => ({
        ...searchInputsData,
      }));
      setFilterStatus(true);
      setFilteredData(filterResult);
    }

    //if search is success
    if (filterSuccess) {
      if (filterResult && !filterResult.statusCode) {
        setFilteredData(filterResult);
      } else {
        setFilteredData([]);
      }
    }
  }, [filterResult, filterSuccess]);

  const filterHierchies = () => {
    filterRefetch();
  };

  return (
    <>
      <HierarchyTable
        filterHierchies={filterHierchies}
        setFilteredData={setFilteredData}
        filteredData={filteredData}
        setFilterStatus={setFilterStatus}
        filterStatus={filterStatus}
        filterLoading={filterLoading}
      />
    </>
  );
};

export default Hierarchy;
